import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const Skill = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <>
      <section
        className="section skills"
        data-aos="fade-in"
        data-aos-anchor-placement="top-bottom"
      >
        <div className="section-title " data-aos="fade-in">
          <h2>Web Development Skills</h2>
          <div className="underline"></div>
        </div>
        <div className="section-center skills-center" data-aos="fade-in">
          <article data-aos="fade-up">
            <h3>Front End</h3>
            <div className="skill">
              <p>Vue / Nuxt</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Java Script</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>React</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Angulat / Material UI / ionic</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70"></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Vuex Store</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Element UI</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Bootstrap</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Formik</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Netlify</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70"></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
          </article>
          <article data-aos="fade-in">
            <h3>Backend End</h3>
            <div className="skill">
              <p>Laravel</p>
              <div className="skill-container">
                <div className="skill-value-70 skill-value"></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Nodejs</p>
              <div className="skill-container">
                <div className="skill-value skill-value-50 "></div>
                <p className="skill-text skill-text-50">50%</p>
              </div>
            </div>
            <div className="skill">
              <p>MongoDB</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>GraphQL</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70"></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Appolo Client</p>
              <div className="skill-container">
                <div className="skill-value "></div>
                <p className="skill-text ">50%</p>
              </div>
            </div>
            <div className="skill">
              <p>Resfull API</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70"></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Heroku</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70"></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
          </article>
        </div>
      </section>
      <section
        className="section skills"
        data-aos="fade-in"
        data-aos-anchor-placement="top-bottom"
      >
        <div className="section-title ">
          <h2>Network Skills</h2>
          <div className="underline"></div>
        </div>
        <div className="section-center skills-center" data-aos="fade-in">
          <article>
            <div className="skill">
              <p>Network Design And Management</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80 "></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>TCP/IP</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80 "></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>CCNA Security</p>
              <div className="skill-container">
                <div className="skill-value"></div>
                <p className="skill-text">50%</p>
              </div>
            </div>
            <div className="skill">
              <p>VLAN Routing</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80 "></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Switching</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70"></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Routing</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>VTP Trunking</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70 "></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>HSRP</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70 "></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
          </article>
          <article>
            <div className="skill">
              <p>NAT/PAT</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70 "></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Cisco ASA</p>
              <div className="skill-container">
                <div className="skill-value"></div>
                <p className="skill-text">50%</p>
              </div>
            </div>
            <div className="skill">
              <p>DMVPN</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70 "></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Access Control Lists</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70 "></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>Cisco ISE</p>
              <div className="skill-container">
                <div className="skill-value skill-value-70 "></div>
                <p className="skill-text skill-text-70">70%</p>
              </div>
            </div>
            <div className="skill">
              <p>VPN</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80"></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>Interior Gateway Routing Protocols</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80 "></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
            <div className="skill">
              <p>BGP</p>
              <div className="skill-container">
                <div className="skill-value skill-value-80 "></div>
                <p className="skill-text skill-text-80">80%</p>
              </div>
            </div>
          </article>
        </div>
      </section>
    </>
  );
};

export default Skill;
